import React from 'react'
import { createRoot } from 'react-dom/client'
import Choices from 'choices.js'
import FloatingLabel from '../components/floating-label'
import replaceQuestion from '../mutations/replace-question'
import createQuestion from '../mutations/create-question'
import updateQuestion from '../mutations/update-question'
import { ApolloProvider, useMutation } from '@apollo/client'
import client from '../client'

function QuestionForm(props) {
  const { categories, stages, learnerTypes } = props
  const [text, setText] = React.useState(props.question.text)
  const [category, setCategory] = React.useState(
    props.question.category || props.category
  )
  const [learnerType, setLearnerType] = React.useState(
    props.question.learnerType || props.question.learner_type
  )
  const [stage, setStage] = React.useState(props.question.stage)
  const [archived, setArchived] = React.useState(props.question.archived)
  const [preview, setPreview] = React.useState(props.question.preview)
  const [replaceQuestionText, setReplaceQuestionText] =
    React.useState('Replace Question')
  const [pAndA, setPAndA] = React.useState(props.question.pAndA || false)
  const [replaceQuestionMutation] = useMutation(replaceQuestion)
  const [createQuestionMutation] = useMutation(createQuestion)
  const [updateQuestionMutation] = useMutation(updateQuestion)

  if (text) {
    if (learnerType === null) {
      setLearnerType('Flexible')
    }
  } else {
    setText('')
    setCategory(categories[0])
    setLearnerType(learnerTypes[0])
    setStage(stages[0])
    setArchived(false)
    setPreview(false)
    setPAndA(false)
  }

  React.useEffect(() => {
    const selects = document.querySelector('.choices')
    if (selects) {
      const opts = { shouldSort: false, shouldSortItems: false }
      const choices = new Choices('.choices', opts) // eslint-disable-line
    }
  }, [])

  const handleTextChange = (e) => {
    setText(e.target.value.replace(/\n/g, ''))
  }

  const handleCategoryChange = (e) => {
    const category = props.categories.filter(
      (c) => Number(c.id) === Number(e.target.value)
    )[0]
    setCategory(category)
  }

  const handleStageChange = (e) => {
    setStage(e.target.value)
  }

  const handleLearnerTypeChange = (e) => {
    setLearnerType(e.target.value)
  }

  const handleArchivedChange = (e) => {
    let isTrue = e.target.value === 'true'
    setArchived(isTrue)
  }

  const handlePreviewChange = (e) => {
    let isTrue = e.target.value === 'true'
    setPreview(isTrue)
  }

  const handlePandAChange = () => {
    setPAndA(!pAndA)
  }

  const handleReplaceQuestion = () => {
    setReplaceQuestionText('Replacing question...')

    replaceQuestionMutation({
      variables: { id: props.question.id },
    }).then((operation) => {
      window.setTimeout(() => {
        setReplaceQuestionText('Question replaced! Redirecting...')
        window.location = `/admin/questions/${operation.payload.data.replaceQuestion.id}/edit?success=Question%20Replaced!`
      }, 2000)
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    const {
      question: { id },
    } = props
    const categoryId = Number(category.id)

    let mutation = null
    let variables = null

    if (id) {
      mutation = updateQuestionMutation
      variables = {
        id,
        categoryId,
        stage,
        learnerType,
        archived,
        preview,
        text,
        pAndA,
      }
    } else {
      mutation = createQuestionMutation
      variables = { categoryId, stage, learnerType, text, preview, pAndA }
    }

    mutation({
      variables: variables,
    }).then(() => {
      window.location.href = '/admin/questions?success=Saved%20Question!'
    })
  }

  return (
    <div className="question-form">
      <form acceptCharset="UTF-8" onSubmit={handleSubmit}>
        <FloatingLabel labelText="Text" labelFor="question_text">
          <textarea
            id="question_text"
            name="question[text]"
            onChange={handleTextChange}
            required
            type="text"
            value={text}
          />
        </FloatingLabel>
        <select
          id="question_category"
          className="choices"
          name="question[category_id]"
          onChange={handleCategoryChange}
        >
          {categories.map((c) => (
            <option value={c.id} selected={c.id === category.id ? 'true' : ''}>
              {c.name}
            </option>
          ))}
        </select>
        <select
          id="question_stage"
          className="choices"
          name="question[stage]"
          onChange={handleStageChange}
        >
          {stages.map((s) => (
            <option value={s} selected={s === stage ? 'true' : ''}>
              {s}
            </option>
          ))}
        </select>
        <select
          id="question_learner_type"
          className="choices"
          name="question[learner_type]"
          onChange={handleLearnerTypeChange}
        >
          {learnerTypes.map((s) => (
            <option value={s} selected={s === learnerType ? 'true' : ''}>
              {s}
            </option>
          ))}
        </select>
        <select
          id="question_archived"
          className="choices"
          name="question[archived]"
          onChange={handleArchivedChange}
        >
          <option value="false" {...(archived ? {} : { selected: true })}>
            Active
          </option>
          <option value="true" {...(archived ? { selected: true } : {})}>
            Archived
          </option>
        </select>
        <select
          id="question_preview"
          className="choices"
          name="question[preview]"
          onChange={handlePreviewChange}
        >
          <option value="false" {...(preview ? {} : { selected: true })}>
            No Preview
          </option>
          <option value="true" {...(preview ? { selected: true } : {})}>
            Preview
          </option>
        </select>
        <div onClick={handlePandAChange}>
          <input
            type="checkbox"
            name="process-and-authority"
            id="process-and-authority"
            checked={pAndA}
          />
          <label htmlFor={'process-and-authority'}>
            <strong>P&A</strong>
          </label>
        </div>
        <br />
        <input type="submit" value="Save Question" />
      </form>
      <br />
      <a onClick={handleReplaceQuestion.bind(this)} href="#">
        {replaceQuestionText}
      </a>
    </div>
  )
}

const questionForm = document.getElementById('question-form')
if (questionForm) {
  const csrfTag = document.querySelector('meta[name=csrf-token]')
  const csrfToken = csrfTag.getAttribute('content')
  const categories = JSON.parse(questionForm.getAttribute('data-categories'))
  const learnerTypes = JSON.parse(
    questionForm.getAttribute('data-learner-types')
  )
  const stages = JSON.parse(questionForm.getAttribute('data-stages'))
  const question = JSON.parse(questionForm.getAttribute('data-question')) || {}
  const category = JSON.parse(questionForm.getAttribute('data-category'))
  const props = {
    csrfToken,
    category,
    categories,
    learnerTypes,
    stages,
    question,
  }

  const root = createRoot(questionForm)
  root.render(
    <ApolloProvider client={client}>
      <QuestionForm {...props} />
    </ApolloProvider>
  )
}

export default QuestionForm
